import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Access token scaduto (8h): si rinnova con il cookie di refresh ("Ricordami" = 90 giorni) e si ritenta.
let rinnovo = null;
const rinnovaSessione = () => {
  if (!rinnovo) {
    rinnovo = axios.post(`${API}/auth/refresh`, null, { withCredentials: true })
      .finally(() => { rinnovo = null; });
  }
  return rinnovo;
};

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config;
  const url = cfg?.url || "";
  if (error?.response?.status !== 401 || !cfg || cfg._ritentata || url.includes("/auth/")) {
    throw error;
  }
  try {
    await rinnovaSessione();
  } catch (e) {
    throw error;
  }
  cfg._ritentata = true;
  return api(cfg);
});

export const rinnovaAccesso = rinnovaSessione;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore imprevisto";
}

export function qs(obj) {
  const p = new URLSearchParams();
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== "all") p.append(k, v);
  });
  return p.toString();
}

/** Scarica un file dall'API (con cookie e rinnovo sessione) e avvia il salvataggio nel browser. */
export async function scaricaFile(path, nomeFallback = "documento.pdf") {
  const r = await api.get(path, { responseType: "blob" });
  const cd = r.headers?.["content-disposition"] || "";
  const m = /filename\*=UTF-8''([^;]+)/i.exec(cd) || /filename="?([^";]+)"?/i.exec(cd);
  const nome = m ? decodeURIComponent(m[1]) : nomeFallback;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
  return nome;
}
